/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

let testTimer;

const initialState = {
  testHasTimer: false,
  isTestExpired: false,
  deadTime: "",
  testExpirationTime: "",
  countDownTime: "00:00:00",
};

const testTimerSlice = createSlice({
  name: "testTimer",
  initialState,
  reducers: {
    isTestExpired(state, action) {
      state.isTestExpired = action.payload;
    },
    setTestExpirationTime(state, action) {
      state.testExpirationTime = action.payload;
    },
    setCountDownTime(state, action) {
      state.countDownTime = action.payload;
    },
    setDeadTime(state, action) {
      state.deadTime = action.payload;
    },
    setTestHasTimer(state, action) {
      state.isTestHasTimer = action.payload;
    },
    resetTimer(state) {
      state.testHasTimer = false;
      state.isTestExpired = false;
      state.deadTime = "";
      state.testExpirationTime = "";
      state.countDownTime = "00:00:00";
    },
  },
});

export const testTimerSelector = (state) => state.testTimer;

export const testTimerActions = testTimerSlice.actions;

const getTimeRemaining = (e) => {
  // const total = Date.parse(e) - Date.parse(new Date());
  const total = Date.parse(e) - Date.parse(new Date());
  // console.log({
  //   total,
  //   e: Date.parse(e),
  //   now: Date.parse(new Date()),
  //   // eslint-disable-next-line no-new-wrappers
  //   diff: new Number(Date.parse(e)) - new Number(Date.parse(new Date())),
  // });
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / 1000 / 60 / 60) % 24);
  return {
    total,
    hours,
    minutes,
    seconds,
  };
};

/**
 * @param {Date} date
 * @returns {string}
 */
const startTimer = (date) => {
  // const expirationTime = new Date(new Date().getTime() + min * 60 * 1000);
  const { total, hours, minutes, seconds } = getTimeRemaining(date);
  if (total > 0) {
    // update the timer
    // check if less than 10 then we need to
    // add '0' at the begining of the variable
    return (dispatch) => {
      const countDownTime = `${hours > 9 ? hours : `0${hours}`}:${
        minutes > 9 ? minutes : `0${minutes}`
      }:${seconds > 9 ? seconds : `0${seconds}`}`;
      // console.log(countDownTime, "countDownTime");
      dispatch(testTimerActions.setCountDownTime(countDownTime));
    };
  }
  return (dispatch) => {
    dispatch(testTimerActions.isTestExpired(true));
  };
};

const getDeadTime = (minutes) => new Date(new Date().getTime() + minutes * 60 * 1000);

const setDeadTime = (minutes) => {
  const deadTime = getDeadTime(minutes);
  return (dispatch) => {
    dispatch(testTimerActions.setDeadTime(deadTime.toISOString()));
  };
};

export const initTimer = (seconds) => {
  if (seconds > 0) {
    const minutes = seconds / 60;
    if (testTimer) clearInterval(testTimer);
    const deadTime = getDeadTime(minutes); // returns a date object
    return (dispatch) => {
      dispatch(testTimerActions.resetTimer());
      dispatch(setDeadTime(minutes));
      testTimer = setInterval(() => {
        dispatch(startTimer(deadTime));
      }, 1000);
      dispatch(testTimerActions.setTestHasTimer(true));
    };
  }
  return (dispatch) => dispatch(testTimerActions.resetTimer());
};

export default testTimerSlice.reducer;
